import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {
  RefundsFaqsComponent
} from '@ruby/modules/revenue/submodules/contract-refunds-help/components/refunds-faqs/refunds-faqs.component';
import {
  RefundsHelpComponent
} from '@ruby/modules/revenue/submodules/contract-refunds-help/components/refunds-help/refunds-help.component';
import {
  RefundsStatusesComponent
} from '@ruby/modules/revenue/submodules/contract-refunds-help/components/refunds-statuses/refunds-statuses.component';

const routes: Routes = [
  {
    path: '',
    component: RefundsHelpComponent,
    children: [
      {
        path: 'statuses',
        component: RefundsStatusesComponent
      },
      {
        path: 'faqs',
        component: RefundsFaqsComponent
      },
      {
        path: '',
        redirectTo: 'statuses',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContractRefundsHelpRoutingModule {}
